import { gql } from "@apollo/client";

export const UPDATE_OBLIGATION = gql`
  mutation UpdateObligation($input: UpdateObligationInput!) {
    updateObligation(input: $input) {
      obligationId
      obligation
      description
      origins
      type
      standard
      reference
      evidences
      obligationClass
      fulfillmentMode
      consequenceOfBreach
      flags
      triggerType
      cadenceInterval
      cadenceLabel
      anchorDate
    }
  }
`;

export const SET_OBLIGATION_STATUS = gql`
  mutation SetObligationStatus($obligationId: ID!, $status: String!) {
    setObligationStatus(obligationId: $obligationId, status: $status) {
      obligationId
      status
    }
  }
`;

export const DELETE_OBLIGATION = gql`
  mutation DeleteObligation($obligationId: ID!) {
    deleteObligation(obligationId: $obligationId)
  }
`;

export const DEACTIVATE_LENS_OBLIGATIONS_MUTATION = gql`
  mutation DeactivateLensObligations($locationId: ID!, $lensKey: String!) {
    deactivateLensObligations(locationId: $locationId, lensKey: $lensKey) {
      success
      deactivatedCount
    }
  }
`;
